import React from 'react'
import { Navbar } from './Navbar'
import styles from "../styles/Welcome.module.scss"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faLinkedin, faTelegram } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faArrowDown } from '@fortawesome/free-solid-svg-icons'


export const Welcome = () => {
    const socialMedia = [{
        href: "https://www.linkedin.com/in/julia-lacerda-582b8214b/",
        icon: faLinkedin
    },
    {
        href: "https://github.com/ailujailuj",
        icon: faGithub
    },
    {
        href: "https://t.me/ailuj_ailuj",
        icon: faTelegram
    },
    {
        href: "mailto:julialacerdaff@gmail.com",
        icon: faEnvelope
    }]


    return (
        <div className={styles.container}>
            <Navbar/>
            <div className={styles.cardContainer}>
                <div className={styles.cardContent}>
                    <h1 className={styles.title}><span className={styles.titleBold}>Olá,</span><br/>me chamo <span className={styles.titleBold}>Julia</span> e sou desenvolvedora front-end.</h1>
                    <p className={styles.introduction}>Sou uma estudante de ciência da computação apaixonada por criar soluções, por programação e pelo desenvolvimento de interfaces bonitas e responsivas. Como desenvolvedora Front-end, trabalhei no desenvolvimento de e-commerces de grandes marcas do mercado nacional.</p>
                    <a href="#projects" className='cta'>Veja meus projetos <FontAwesomeIcon className='ctaIcon' icon={faArrowDown}/></a>
                    <p className={styles.location}>Florianópolis, Brasil</p>
                    <div className={styles.socialMedia}>
                        {socialMedia.map((item) => {
                            return (
                                <a className={styles.socialMediaLink} href={item.href}>
                                     <FontAwesomeIcon className={styles.socialMediaIcon} icon={item.icon} />
                                </a>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}